var map = {
	"./SSI.json": "9a62",
	"./SSIBasicIssuanceModule.json": "21d6",
	"./air.json": "5651",
	"./blender.json": "bb6e",
	"./booster.json": "4795",
	"./clickGame.json": "73ba",
	"./erc20.json": "ab45",
	"./exchange.json": "1e27",
	"./gravity.json": "7977",
	"./interstellar.json": "c1d8",
	"./launchpadPreSale.json": "87fa",
	"./launchpadSale.json": "b8ce",
	"./launchpadSaleOld.json": "e46c",
	"./launchpadSimpleSale.json": "6c57",
	"./launchpadStaking.json": "aa6a",
	"./launchpadStakingShake.json": "2c9d",
	"./launchpadVesting.json": "6794",
	"./launchpadWarpSale.json": "dc9b",
	"./launchpadWhiteList.json": "6030",
	"./lp.json": "1d1d",
	"./newnftfarm.json": "82f07",
	"./newnftprovider.json": "bdd6",
	"./nftfarm.json": "5b85",
	"./nftprovider.json": "5131",
	"./playground.json": "a9ef",
	"./shadow.json": "d745",
	"./shadowBridge.json": "76b0",
	"./sidusPresale.json": "5a86",
	"./token.json": "d887",
	"./uniFactory.json": "3e02",
	"./uniPair.json": "75ce",
	"./uniRouter.json": "65d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a3bd";